import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { GapSettings } from '../config/gapsettings';
import { UserService } from './user.service';
import { StorageService } from './storage.service';
import { DeviceService } from '../utils/device.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class AppBootstrapService {
  private initialized = false;

  constructor(
    private platform: Platform,
    private storageService: StorageService,
    private gapsettings: GapSettings,
    private deviceService: DeviceService,
    private userService: UserService,
    private languageService: LanguageService,
  ) {}

  async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    }

    await this.platform.ready();

    try {
      await this.storageService.initializeForSyncAccess(['userData', 'sessionState', 'lastVisitedUrl']);
      await this.userService.hydrateFromStorage();

      await Promise.all([
        this.gapsettings.loadFromStorage(),
        this.deviceService.init(),
        this.languageService.init()
      ]);
    } catch (error) {
      console.error('AppBootstrapService: initialization failed', error);
    }

    this.initialized = true;
  }
}
